import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router, Event, NavigationStart } from '@angular/router';
import { filter, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollRestorationService {
  private scrollRestorePosition: Map<string, [number, number]> = new Map<string, [number, number]>();
  scrollNotifier: Subject<void> = new Subject<void>();

  constructor(private router: Router, private viewPortScroller: ViewportScroller, @Inject(DOCUMENT) private dom: Document) {
  }

  listenToNavigationEvents() {
    this.router.events.pipe(filter((event: Event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(event => {
        // consider checking the navigation trigger here. ie imperative vs popstate
        this.setScrollPosition(this.router.url, this.viewPortScroller.getScrollPosition());
        if (event.navigationTrigger === 'popstate') {
          // Add listener scroll restoration
          this.listenToScrollNotifier();
        }
      });
  }

  private restoreScrollPosition(url: string) {
    const position = this.getScrollPosition(url);
    if (position) {
      this.viewPortScroller.scrollToPosition(position);
    }
  }

  private setScrollPosition(url: string, position: [number, number]) {
    this.scrollRestorePosition.set(url, position);
  }

  private getScrollPosition(url: string): [number, number] | undefined {
    return this.scrollRestorePosition.get(url);
  }

  private listenToScrollNotifier() {
    const notifier = this.scrollNotifier.subscribe(() => {
      this.restoreScrollPosition(this.router.url);
      notifier.unsubscribe();
    });
  }
}
